import { type Ref, watchEffect } from 'vue'
import { useRouter } from 'vue-router'

export function useMarkdownLinkNavigation(elementRef: { value: HTMLElement | null | undefined }, linkUrl: Ref<string>) {
  const router = useRouter()

  watchEffect((onCleanup) => {
    const element = elementRef.value
    if (!element) {
      return
    }

    const linkValue = linkUrl.value

    const handleClick = (event: Event) => {
      const target = event.target as HTMLElement
      const anchor = target.closest('a')
      if (anchor && anchor.getAttribute('href') === linkValue) {
        event.preventDefault()
        router.push(linkValue)
      }
    }

    element.addEventListener('click', handleClick)
    onCleanup(() => {
      element.removeEventListener('click', handleClick)
    })
  })
}
